import BookDemoButton, { IProps } from './BookDemoButton';

export type { IProps };
export default BookDemoButton;
